import type { UseFormReturn } from "react-hook-form"
import type { FIELD } from "../types/form-types"
import { FieldFactory } from "./field-factory"

interface FieldProps {
	form: UseFormReturn
	field: FIELD
}

export const Field = ({ field, form }: FieldProps) => {
	return (
		<div
			key={field.field_id}
			className="space-y-2"
		>
			<FieldFactory
				field={field}
				form={form}
			/>
		</div>
	)
}
